import { type Translationtype } from "utils";
import { type FieldErrors, Controller, type Control } from "react-hook-form";

interface IFormSwitchInputProps {
  control: Control<any>;
  errors: FieldErrors;
  className?: string;
  disabled?: boolean;
  name: string;
  t: Translationtype;
}

export function FormSwitchInput({
  control,
  errors,
  className,
  disabled,
  name,
  t,
}: IFormSwitchInputProps) {
  return (
    <div className={`${className ?? ""} flex flex-row items-center w-fit`}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <input
            type="checkbox"
            id={name}
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            disabled={disabled ?? false}
            className="toggle toggle-success"
          />
        )}
      />
      {errors[name]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(errors[name]?.message as any)}
        </p>
      ) : null}
    </div>
  );
}
